import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const enhanceTable = (table) => {
  if (table.classList.contains('no-mobile-cards')) return;
  const headers = [...table.querySelectorAll('thead th')].map((cell) => cell.textContent.trim());
  if (!headers.length) return;
  table.classList.add('dashboard-card-table');
  table.querySelectorAll('tbody tr').forEach((row) => {
    const cells = [...row.children].filter((cell) => cell.tagName === 'TD');
    if (cells.length === 1 && Number(cells[0].getAttribute('colspan') || 1) > 1) {
      row.classList.add('dashboard-card-table-empty');
      return;
    }
    cells.forEach((cell, index) => {
      if (!cell.dataset.label) cell.dataset.label = headers[index] || `Detail ${index + 1}`;
    });
  });
  table.dataset.mobileCardsReady = 'true';
};

const ResponsiveDashboardTables = () => {
  const location = useLocation();
  useEffect(() => {
    const root = document.querySelector('.dashboard-content');
    if (!root) return undefined;
    let frame = 0;
    const enhance = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => root.querySelectorAll('table').forEach(enhanceTable));
    };
    enhance();
    const observer = new MutationObserver(enhance);
    observer.observe(root, { childList: true, subtree: true });
    return () => { observer.disconnect(); window.cancelAnimationFrame(frame); };
  }, [location.pathname]);
  return null;
};

export default ResponsiveDashboardTables;
